// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.SingleUser[data-v-547f055a] {\n  display: none;\n}\n.hidden[data-v-547f055a] {\n  display: none;\n}\n", ""]);
// Exports
module.exports = exports;
